export default __webpack_public_path__ + "static/media/icon-wifi.b677d0af.svg";